import { envAdapters } from './env-adapters';

export const Adapters = {
  ...envAdapters,
};

export default Adapters;
